import React, { useState } from "react";
import { Link } from "react-router-dom";
import Button from "../Button";
import Application from "./Application/Application";
import Home from "./Home/Home";
import Payment from "./Payment";
import Helpline from "./Helpline";
import { FaHome } from "react-icons/fa";
import { AiFillDollarCircle } from "react-icons/ai";
import { BiSolidPhoneCall } from "react-icons/bi";
import { MdEventAvailable } from "react-icons/md";
import ExpertAvailability from "./ExpertAvailability";
import SmallScreenPopup from "./SmallScreenWarningPopup";

const DashboardLayout = ({ handleLogout, expertDetails }) => {
  const [activeTab, setActiveTab] = useState("application");
  const [showApplication, setShowApplication] = useState(false);

  const handleTabClick = (tab) => {
    setActiveTab(tab);
    setShowApplication(false);
  };

  // const handleApplicationClick = () => {
  //   setActiveTab("application");
  //   setShowApplication(true);
  // };

  const renderContent = () => {
    switch (activeTab) {
      case "home":
        return <Home handleLogout={handleLogout} expertDetails={expertDetails} />;
      case "payment":
        return <Payment />;
      case "availability":
        return <ExpertAvailability expertDetails={expertDetails} />;
      case "helpline":
        return <Helpline />;
      case "application":
        return <Application expertDetails={expertDetails} />;
      default:
        return null;
    }
  };

  return (
    <div className="bg-[#1E293B] font-josefin-sans flex h-screen">
      <div className="flex flex-col items-center w-1/5">
        <Link to="/problemsolver/dashboard">
          <div className=" flex items-center py-5">
            <img
              src={process.env.PUBLIC_URL + "/images/logo-dashboard.png"}
              alt="Logo"
              className="w-[10rem] "
              // className="w-20 h-full object-contain filter brightness-0 invert"
            />
          </div>
        </Link>
        <div
          className={`mb-5 bg-gradient-to-r from-yellow-300 to-lime-200 text-2xl font-bold px-14  py-3 rounded-lg cursor-pointer hover:bg-gradient-to-r hover:from-lime-200 hover:to-yellow-300
        `}
          onClick={() => handleTabClick("application")}
          isActive={activeTab === "application"}
        >
          Application
        </div>
        <div className="bg-black w-full h-px"></div>
        <Button
          icon={<FaHome />}
          label="Home"
          onClick={() => handleTabClick("home")}
          isActive={activeTab === "home"}
        />
        <Button
          icon={<AiFillDollarCircle />}
          label="Payment"
          onClick={() => handleTabClick("payment")}
          isActive={activeTab === "payment"}
        />
        <Button
          icon={<MdEventAvailable />}
          label="Availability"
          onClick={() => handleTabClick("availability")}
          isActive={activeTab === "availability"}
        />
        <Button
          icon={<BiSolidPhoneCall />}
          label="Help Line"
          onClick={() => handleTabClick("helpline")}
          isActive={activeTab === "helpline"}
        />
      </div>
      <div className="bg-black w-[1px]"></div>
      <div className="bg-gray-100 w-4/5 overflow-auto">
        {showApplication ? <Application /> : renderContent()}
      </div>
      <div className="lg:hidden">
        <SmallScreenPopup />
      </div>
    </div>
  );
};

export default DashboardLayout;
